import { lazy } from 'react';

import type { RouteConfig } from '../../types';

// Lazy load dashboard layout
const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));
const RemittanceSectionLayout = lazy(() => import('@/pages/remittance/layout'));
const RemittanceLayout = lazy(() => import('@/pages/remittance/[remittanceId]/layout'));

// Lazy load remittance pages
const RemittancePage = lazy(() => import('@/pages/remittance'));
const CreateRemittancePage = lazy(() => import('@/pages/remittance/create'));
const RemittanceDetailPage = lazy(() => import('@/pages/remittance/[remittanceId]/details'));

/**
 * Remittance routes
 * Handles remittance management
 */
export const remittanceRoutes: RouteConfig = {
  path: '/remittance',
  layout: DashboardLayout,
  children: [
    {
      path: '',
      layout: RemittanceSectionLayout,
      children: [
        {
          path: '',
          element: RemittancePage,
        },
        {
          path: '/create',
          element: CreateRemittancePage,
        },
      ],
    },
    {
      path: '/:remittanceId',
      layout: RemittanceLayout,
      children: [
        {
          path: '/details',
          element: RemittanceDetailPage,
        },
      ],
    },
  ],
};
